import { apolloService } from 'app/services';
import { PATCH_ASSIGNMENT_MUTATION } from 'app/gql/mutations/PATCH_ASSIGNMENT_MUTATION';

export const patchAssignment = async ( courseID, input ) => {
  const data = await apolloService.mutate( {
    mutation: PATCH_ASSIGNMENT_MUTATION,
    variables: { input: input }
  } );

  if ( !data || data === null ) {
    console.error( 'Patching assignment Response is NULL: ', data );
  } else {
    console.log( 'Patching assignment Response: ', data );
  }
};
